import type { AdminConfig, AuditRecord, ListResponse, ModelInfo } from './types';

const TOKEN_KEY = 'ai_audit_dashboard_token';

export function getToken(): string {
  return localStorage.getItem(TOKEN_KEY) ?? '';
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export async function login(email: string, password: string): Promise<string> {
  const response = await fetch('/api/v1/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  });
  const payload = await response.json();
  if (!response.ok) {
    throw new Error(payload?.error?.message ?? 'Не удалось войти');
  }
  return payload.token;
}

export async function fetchAudits(params: URLSearchParams): Promise<ListResponse> {
  const response = await apiFetch(`/api/v1/audits?${params.toString()}`);
  return response.json();
}

export async function fetchAudit(id: string): Promise<AuditRecord> {
  const response = await apiFetch(`/api/v1/audits/${id}`);
  return response.json();
}

export async function fetchAdminConfig(): Promise<AdminConfig> {
  const response = await apiFetch('/api/v1/admin/config');
  return response.json();
}

export async function fetchModels(): Promise<ModelInfo[]> {
  const response = await apiFetch('/api/v1/models');
  const payload = await response.json();
  return payload.data ?? [];
}

async function apiFetch(path: string): Promise<Response> {
  const response = await fetch(path, {
    headers: { Authorization: `Bearer ${getToken()}` }
  });
  if (!response.ok) {
    let message = 'Запрос не выполнен';
    try {
      const payload = await response.json();
      message = payload?.error?.message ?? message;
    } catch {
      message = response.statusText;
    }
    throw new Error(message);
  }
  return response;
}
